module.exports = __webpack_public_path__ + "img/niews-6.a779273c.jpeg";